export default "__VITE_ASSET__cd793495__"